<script>
  import Button from '../button/Button.svelte';
  import LoadingSpinner from '../loader/LoadingSpinner.svelte';
  import Note from '../note/Note.svelte';

  export let onCancel;
  export let onRetry;
  export let onAccept;

  export let loading = false;
</script>

<style lang="postcss">
  .rephrase-info-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .rephrase-buttons {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
  }

  pre {
    line-break: auto;
    white-space: break-spaces;
  }
</style>

<Note variant="success">
  <div class="rephrase-info-container">
    <pre><slot /></pre>

    <label for="buttons">What do you want to do with this suggestion?</label>
    <div id="buttons" class="rephrase-buttons">
      <Button
        on:click={onCancel}
        disabled={loading}
        type="button"
        class="secondary">Cancel</Button>
      <Button
        on:click={onRetry}
        disabled={loading}
        type="button"
        class="secondary">
        {#if loading}
          <LoadingSpinner />
        {:else}
          Retry
        {/if}
      </Button>
      <Button on:click={onAccept} disabled={loading} type="button"
        >Accept</Button>
    </div>
  </div>
</Note>
